<template>

  <div>
    <form novalidate class="md-layout">
      <md-card class="md-layout-item md-size-100">
        <md-card-header>
          <div class="md-title">Ordine di scarico</div>
        </md-card-header>
        <md-card-content>
          <div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-20">
                <md-vuelidated>
                  <label for="deliveryNote">Delivery note</label>
                  <md-input type="text" v-model="fields.deliveryNote" :disabled="!edit" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <div v-show="edit">
                  <md-vuelidated field="md-datepicker" class="maxwidth220" v-model="fields.orderDate" md-immediately :disabled="!edit">
                    <label for="orderDate">Order Date</label>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                </div>
                <div v-show="!edit" class="input-display">
                  <label for="orderDate">Order Date</label>
                  <div class="input-value">{{fields.orderDate | formatDate}}</div>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <!-- md-vuelidated -->
                <md-field>
                  <label for="ordineDiCarico">Ordine di Carico</label>
                  <md-input type="text" v-model="fields.ordineDiCarico" :disabled="!edit" />
                </md-field>
                  <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
                <!-- /md-vuelidated -->
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <!-- md-vuelidated -->
                <md-field>
                  <label for="elogate">ELOGATE</label>
                  <md-input type="text" v-model="fields.elogate" :disabled="!edit" />
                </md-field>
                  <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
                <!-- /md-vuelidated -->
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-50">
                <!-- md-vuelidated -->
                <md-field>
                  <label for="transportMean">Transport mean</label>
                  <md-input type="text" v-model="fields.transportMean" :disabled="!edit" />
                </md-field>
                  <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
                <!-- /md-vuelidated -->
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <!-- md-vuelidated -->
                <md-field>
                  <label for="pos">Pos</label>
                  <md-input type="text" v-model="fields.pos" :disabled="!edit" />
                  <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
                <!-- /md-vuelidated -->
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <!-- md-vuelidated -->
                <md-field>
                  <label for="cmr">CMR</label>
                  <md-input type="text" v-model="fields.cmr" :disabled="!edit" />
                  <!-- md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg -->
                <!-- /md-vuelidated -->
                </md-field>
              </div>
            </div>
            <div class="md-layout form-action">
              <md-button type="button"
                         class="md-primary md-raised"
                         :disabled="saving"
                         v-show="!edit"
                         @click="modify()">Modifica</md-button>
               <md-button type="button"
                        class="md-primary md-raised"
                        :disabled="saving"
                        to="/scarico">Indietro</md-button>
              <md-button type="button"
                         class="md-primary md-raised"
                         :disabled="saving"
                         v-show="edit"
                         @click="save()">Conferma</md-button>
              <md-button type="button" class="md-primary" :disabled="saving" v-show="edit" @click="reload()">Annulla</md-button>
            </div>
            <md-card class="md-layout-item md-size-100">
              <md-card-header>
                <div class="md-title">Documenti</div>
              </md-card-header>
              <md-card-content>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item documento">
                        <h3>Ordine di carico</h3>
                        <div class="testo">
                          <md-field>
                            <label>Seleziona file</label>
                            <md-file v-model="documenti.carico.name" accept="application/pdf" @md-change="documenti.carico = $event[0]" :disabled="documenti.carico.uploaded" />
                          </md-field>
                          <md-button class="md-icon-button md-dense md-raised md-accent" v-show="documenti.carico.uploaded" @click="dropDocumento(1)">
                            <md-icon>delete</md-icon>
                          </md-button>
                          <md-button class="md-icon-button md-dense md-raised md-primary" v-show="documenti.carico.name != '' && !documenti.carico.uploaded" @click="upload(documenti.carico,1)">
                            <md-icon>upload_file</md-icon>
                          </md-button>
                        </div>
                    </div>
                    <div class="md-layout-item documento">
                        <h3>Delivery note di uscita</h3>
                        <div class="testo">
                          <md-field>
                            <label>Seleziona file</label>
                            <md-file v-model="documenti.scarico.name" accept="application/pdf" @md-change="documenti.scarico = $event[0]" :disabled="documenti.scarico.uploaded"/>
                          </md-field>
                          <md-button class="md-icon-button md-dense md-raised md-accent" v-show="documenti.scarico.uploaded" @click="dropDocumento(2)">
                            <md-icon>delete</md-icon>
                          </md-button>
                          <md-button class="md-icon-button md-dense md-raised md-primary" v-show="documenti.scarico.name != '' && !documenti.scarico.uploaded"  @click="upload(documenti.scarico,2)">
                            <md-icon>upload_file</md-icon>
                          </md-button>
                        </div>
                    </div>
                  </div>
              </md-card-content>
            </md-card>
            <div class="md-layout">
              <md-toolbar md-elevation="0">
                <h3 class="md-title" style="flex: 1">Dettaglio</h3>
                <!--md-button class="md-icon-button" @click="addRow()" v-show="fields.id">
                  <md-icon>add</md-icon>
                </md-button-->
              </md-toolbar>
              <md-table class="fullScreen">
                <md-table-row>
                  <md-table-head>POS</md-table-head>
                  <md-table-head>Mat. Number (SAP)</md-table-head>
                  <md-table-head class="desc">Description</md-table-head>
                  <md-table-head>Elogate</md-table-head>
                  <md-table-head>Pcs/Unit</md-table-head>
                  <md-table-head>Packaging amount</md-table-head>
                  <md-table-head>Quantity</md-table-head>
                  <md-table-head>Weight</md-table-head>
                  <md-table-head class="action">&nbsp;</md-table-head>
                </md-table-row>
                <template v-for="row in sortedRows">
                      <md-table-row :key="row.pos">
                        <md-table-cell md-numeric>{{row.pos}}</md-table-cell>
                        <md-table-cell>{{row.materialNumber}}</md-table-cell>
                        <md-table-cell  class="desc">{{row.description}}</md-table-cell>
                        <md-table-cell>{{row.elogate}}</md-table-cell>
                        <md-table-cell>{{row.pcsUnit.quantity}} / {{row.pcsUnit.unit}}</md-table-cell>
                        <md-table-cell>{{row.packagingAmount.quantity}} / {{row.packagingAmount.unit}}</md-table-cell>
                        <md-table-cell>{{row.quantity.quantity}} / {{row.quantity.unit}}</md-table-cell>
                        <md-table-cell>{{row.weight.quantity}} / {{row.weight.unit}}</md-table-cell>
                        <md-table-cell>
                          <!--md-button class="md-icon-button" @click="onEditRow(row)" :disabled="edit">
                            <md-icon>edit</md-icon>
                          </md-button>
                          <md-button class="md-icon-button" @click="onDeleteRow(row)" :disabled="edit">
                            <md-icon>delete_forever</md-icon>
                          </md-button>
                          <md-button class="md-icon-button" @click="print(row)" :disabled="edit">
                            <md-icon>print</md-icon>
                          </md-button -->
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row :key="row.pos" class="sscc">
                        <md-table-cell colspan="8">
                          <div class="ssccToolbar">
                            <strong>SSCC No.:</strong>
                            <!-- md-button class="md-icon-button md-dense" @click="addSSCC(row.id)">
                              <md-icon>add</md-icon>
                            </md-button -->
                          </div>
                          <div class="ssccList">
                            <div class="ssccNumber" v-for="sscc in row.ssccNumber" :key="sscc.number" :class="{'broken' : sscc.rotto}">
                              <span>{{sscc.pallet}}</span>
                              <span>
                                <!--md-button class="md-icon-button md-dense" @click="brokenSSCC(sscc)">
                                  <md-icon>broken_image</md-icon>
                                </md-button>
                                <md-button class="md-icon-button md-dense" @click="removeSSCC(sscc)">
                                  <md-icon>delete</md-icon>
                                </md-button>
                                <md-button class="md-icon-button md-dense" @click="editSSCC(sscc)">
                                  <md-icon>edit</md-icon>
                                </md-button-->
                              </span>
                            </div>
                          </div>
                        </md-table-cell>
                      </md-table-row>
                    </template>
              </md-table>
            </div>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button type="button" class="md-primary md-raised" :disabled="saving" @click="abort()">Chiudi</md-button>
        </md-card-actions>
      </md-card>
      <CaricoRowEdit :showEditRowDialog="showEditRowDialog" @close-edit="showEditRowDialog = false" v-bind:currentRow="editRowData"
                     v-on:save-row="onSaveRow"></CaricoRowEdit>
      <ScaricoSSCCEdit :showEditSSCCDialog="showEditSSCCDialog"
                      @close-sscc-edit="showEditSSCCDialog = false"
                      v-bind:editSSCData="editSSCData"
                      v-on:save-sscc-row="onSavePalletRow"></ScaricoSSCCEdit>
  </div>

</template>
<script>

  import moment from 'moment'
  import axios from 'axios'
  import print from 'print-js'
  import { validationMixin } from 'vuelidate'
  import CaricoRowEdit from './CaricoRowEdit.vue'
  import ScaricoSSCCEdit from './ScaricoSSCCEdit.vue'
  import ErrorService from "../Services/ErrorService";

  import { required } from 'vuelidate/lib/validators'

  const instance = axios.create({
    baseURL: window.appCfg.serviceURI
  })

  instance.interceptors.request.use(config => {
    config.headers.common['Access-Control-Allow-Origin'] = '*'
    return config
  })

  export default {
    name: 'CaricoEdit',
    mixins: [validationMixin],
    components: {
      CaricoRowEdit,
      ScaricoSSCCEdit
    },
    data: function() {
      return {
        showEditRowDialog: false,
        showEditSSCCDialog: false,
        editRowData: {},
        editSSCData: {},
        depots: {},
        edit: false,
        documenti: {
          carico: { name: '' },
          scarico: { name: '' }
        },
        fields: {
          id: 0,
          details: [],
          orderDate: new Date(),
          //deliveryDate: new Date(),
          deliveryNote: '',
          ordineDiCarico: '',
          transportMean: '',
          pos: '',
          cmr: '',
          elogate: '',
          //depot: 0,
          //numeroMagazzino: '',
          grossWeight: {
            quantity: '',
            unit: 'KG'
          },
          netWeight: {
            quantity: '',
            unit: 'KG'
          }
        },
        editRow: false
      }
    },
    validations: {
      fields: {
        deliveryNote: {
          required
        },
        /*ordineDiCarico : {
          required
        },
        elogate: {
          required
        },
        pos: {
          required
        },
        cmr: {
          required
        },*/
        /*depot: {
          required,
          notEmpty : function(value) {
            return parseInt(value) > 0
          }
        },
        numeroMagazzino: {
          required
        },*/
        orderDate: {
          required
        },/*
        deliveryDate: {
          required
        },*/
        /*transportMean: {
          required
        },
        grossWeight: {
          quantity: {
            required
          },
          unit: {
            required
          }
        },
        netWeight: {
          quantity: {
            required
          },
          unit: {
            required
          }
        }*/
      }
    },
    mounted() {
      this.depots = window.appCfg.depots
      if (this.$route.params.id !== undefined) this.load(this.$route.params.id)
    },
    computed: {
      sortedRows: function() {
        return this.fields.details.sort((p1, p2) => {
          if (p1['pos'] < p2['pos']) return -1
          if (p1['pos'] > p2['pos']) return 1
          return 0
        })
      }
    },
    methods: {
      abort() {
        if (!this.edit) {
          this.$router.push('/carico')
          return
        }
        this.$fire({
          title: '',
          html: "Annullare tutte le modifiche?",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Conferma'
        }).then(result => {
          if (result.value) {
            this.$router.push('/scarico')
          }
        })
      },
      load: function(id) {
        let params = {
          action: 'load',
          id: id
        }
        let loading = this.$loading.show();
        this.$http
          .post('/data/scarico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.edit = false
              this.fields = response.data.data
              // Converto in data
              this.fields.orderDate = new Date(this.fields.orderDate)
              //this.fields.deliveryDate = new Date(this.fields.deliveryDate)
              // Allegati
              this.documenti.carico = this.fields.documenti.carico
              this.documenti.scarico = this.fields.documenti.scarico
            } else {
              this.$fire({
                html: 'Errore di sistema: ' + response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
      },
      reload() {
        this.edit = false
        if (this.$route.params.id) {
          this.load(this.$route.params.id)
        } else {
          this.fields = {
            id: 0,
            details: [],
            orderDate: new Date(),
            //deliveryDate: new Date(),
            deliveryNote: '',
            transportMean: '',
            pos: '',
            cmr: '',
            //depot: 0,
            //numeroMagazzino: '',
            grossWeight: {
              quantity: '',
              unit: 'KG'
            },
            netWeight: {
              quantity: '',
              unit: 'KG'
            }
          }
        }
      },
      print(row) {
        axios.get('/print/etichetta').then(response => {
          if (response.data) {
            response.data = response.data.replace('{DN}', this.fields.deliveryNote)
            response.data = response.data.replace('{POS}', this.fields.pos)
            response.data = response.data.replace('{MN}', row.materialNumber)
            response.data = response.data.replace('{TIPO}', row.description)
            response.data = response.data.replace('{DATA}', this.fields.orderDate)
            response.data = response.data.replace('{DEP}', this.depots[this.fields.depot])

            document.getElementById('print-container').innerHTML = response.data
            printJS({ printable: 'print-container', type: 'html', documentTitle: '', header: '' })
          }
        })
      },
      upload: function(pdf, type) {
        let loading = this.$loading.show();
        let formData = new FormData()
        formData.append('file', pdf)
        formData.append('type', type)
        formData.append('id', this.fields.id)
        this.$http.post('/data/upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer ' + this.$cookie.get('token')
            }
        }).then(response => {
          loading.hide()
          if (
            response.status == 200
          ) {
            if (response.data.done) {
              this.$fire({
                html: response.data.message,
                type: 'success'
              }).then(r => {
                this.load(this.$route.params.id)
              })
            } else {
              this.$fire({
                html: response.data.message,
                type: 'error'
              })
            }
          } else {
            this.$fire({
              html: response.statusText ? response.statusText : 'Errore di sistema',
              type: 'error'
            })
          }
        })
        .catch(response => {
          loading.hide()
          this.$fire({
            html: 'Errore di sistema',
            type: 'error'
          })
        })
      },
      dropDocumento: function(type) {
        this.$fire({
          title: 'Cancellare il documento?',
          html: "Non sar&agrave; possibile annullare l'operazione",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Cancella'
        }).then(result => {
          if (result.value) {
            let loading = this.$loading.show();
            this.$http
              .post(
                '/data/drop-documento',
                { id: this.fields.id, type : type },
                { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
              )
              .then(response => {
                loading.hide()
                if (
                  response.status == 200
                ) {
                  if (response.data.done) {
                    this.$fire({
                      html: response.data.message,
                      type: 'success'
                    }).then(r => {
                      this.load(this.$route.params.id)
                    })
                  } else {
                    this.$fire({
                      html: response.data.message,
                      type: 'error'
                    })
                  }
                } else {
                  this.$fire({
                    html: response.statusText ? response.statusText : 'Errore di sistema',
                    type: 'error'
                  })
                }
              })
              .catch(response => {
                loading.hide()
                this.$fire({
                  html: 'Errore di sistema',
                  type: 'error'
                })
              })
          }
        })
      },
      onDeleteRow: function(row) {
        this.$fire({
          title: 'Cancellare la riga?',
          html: "Non sar&agrave; possibile annullare l'operazione",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Cancella'
        }).then(result => {
          if (result.value) {
            this.$http
              .post(
                '/data/scarico',
                { action: 'delete', what: 'row', id: row.id },
                { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
              )
              .then(deleteResponse => {
                if (deleteResponse.data.done) {
                  this.$fire({
                    html: 'Cancellata!',
                    type: 'success'
                  }).then(r => {
                    this.load(this.$route.params.id)
                  })
                } else {
                  this.$fire({
                    html: deleteResponse.data.message,
                    type: 'error'
                  }).then(r => {
                    if (response.data.bu != '') {
                      this.$router.push(response.data.bu)
                    }
                  })
                }
              })
          }
        })
      },
      onSaveRow: function(data) {
        let params = {
          action: 'save',
          what: 'row',
          headerid: this.fields.id,
          data: data
        }
        let loading = this.$loading.show();
        this.$http
          .post('/data/scarico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.showEditRowDialog = false
              this.load(this.fields.id)
            } else {
              this.$fire({
                html: response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
          .catch(function(error) {
            loading.hide()
            ErrorService.error('Errore di sistema: ' + error.response ? error.response : error.message)
          })
      },
      onSavePalletRow: function(data) {
        this.showEditSSCCDialog = false
        let params = {
          action: 'save',
          what: 'pallet',
          rowid: data.rowId,
          data: data
        }
        let loading = this.$loading.show();
        this.$http
          .post('/data/scarico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.showEditSSCCDialog = false
              this.load(this.fields.id)
            } else {
              this.$fire({
                html: response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
          .catch(function(error) {
            loading.hide()
            ErrorService.error('Errore di sistema: ' + error.response ? error.response : error.message)
          })
      },
      modify() {
        this.edit = true
      },
      save() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }

        this.fields.orderDate = moment(String(this.fields.orderDate)).format('YYYY-MM-DD')
      //  this.fields.deliveryDate = moment(String(this.fields.deliveryDate)).format('YYYY-MM-DD')

        let params = {
          action: 'save',
          what: 'head',
          data: this.fields
        }

        let loading = this.$loading.show();
        this.$http
          .post('/data/scarico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.edit = false
              if (!this.fields.id) this.fields.id = response.data.id
              //   this.$fire({
              //     html: 'Ordine di carico salvato',
              //     type: 'success',
              //     showCloseButton: true,
              //     showCancelButton: false
              //   }).then(r => {
              //     this.$router.push('/carico')
              //   })
            } else {
              this.$fire({
                html: response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
          .catch(function(error) {
            loading.hide()
            ErrorService.error('Errore di sistema: ' + error.response ? error.response : error.message)
          })
      },
      addSSCC(rowId) {
        this.showEditSSCCDialog = true
        this.editSSCData = {
          id: 0,
          rowId: rowId,
          number: '',
          pallet: '',
          rotto: false
        }
      },
      editSSCC(row) {
        this.editSSCData = {
          id: row.id,
          rowId: 0,
          number: row.number,
          pallet: row.pallet,
          rotto: row.rotto
        }
        this.showEditSSCCDialog = true
        console.log(this.editSSCData)
      },
      brokenSSCC(row) {
        this.$http
          .post(
            '/data/scarico',
            { action: 'broken', what: 'pallet', id: row.id , rotto : !row.rotto},
            { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
          )
          .then(deleteResponse => {
            if (deleteResponse.data.done) {
              row.rotto = !row.rotto
            } else {
              this.$fire({
                html: deleteResponse.data.message,
                type: 'error'
              })
            }
          })
      },
      removeSSCC(row) {
        this.$fire({
          title: 'Cancellare il pallet?',
          html: "Non sar&agrave; possibile annullare l'operazione",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Cancella'
        }).then(result => {
          if (result.value) {
            this.$http
              .post(
                '/data/scarico',
                { action: 'delete', what: 'pallet', id: row.id },
                { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
              )
              .then(deleteResponse => {
                if (deleteResponse.data.done) {
                  this.$fire({
                    html: 'Cancellato!',
                    type: 'success'
                  }).then(r => {
                    this.load(this.$route.params.id)
                  })
                } else {
                  this.$fire({
                    html: deleteResponse.data.message,
                    type: 'error'
                  }).then(r => {
                    if (response.data.bu != '') {
                      this.$router.push(response.data.bu)
                    }
                  })
                }
              })
          }
        })
      },
      addRow() {
        this.showEditRowDialog = true
        this.editRowData = {
          id: 0,
          pos: '',
          materialNumber: '',
          description: '',
          pcsUnitQuantity: '',
          pcsUnitUnit: 'PAL',
          packagingAmountQuantity: '',
          packagingAmountUnit: 'PAL',
          quantityQuantity: '',
          quantityUnit: 'PC',
          weightQuantity: '',
          weightUnit: 'KG'
        }
      },
      onEditRow(row) {
        this.editRowData = {
          id: row.id,
          pos: row.pos,
          materialNumber: row.materialNumber,
          description: row.description,
          pcsUnitQuantity: row.pcsUnit.quantity,
          pcsUnitUnit: row.pcsUnit.unit,
          packagingAmountQuantity: row.packagingAmount.quantity,
          packagingAmountUnit: row.packagingAmount.unit,
          quantityQuantity: row.quantity.quantity,
          quantityUnit: row.quantity.unit,
          weightQuantity: row.weight.quantity,
          weightUnit: row.weight.unit
        }
        this.showEditRowDialog = true
      },
      close() {}
    }
  }

</script>

<style>

  .md-content.fullScreen {
    width: 100%;
    max-width: 100%;
    padding: 10px 0;
  }
  .md-table .md-table-content {
    width: 100%;
    max-width: 100%;
    padding: 0;
  }
  .desc {
    max-width: 320px;
  }
  tr.md-table-row > td {
    text-align: left;
  }
  .sscc > td {
    border-top: 0px !important;
  }
  .ssccList {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .ssccNumber {
    /* max-width: 200px; */
    /* width: 200px; */
    text-align: left;
    display: flex;
    align-items: center;
    min-width: 20%;
    justify-content: space-between;
  }
  .md-field .md-error {
    display: block !important;
    left: 0;
    opacity: 0;
    transform: translate3d(0, -8px, 0);
  }
  .md-field .md-count,
  .md-field .md-error,
  .md-field .md-helper-text {
    height: 20px;
    position: absolute;
    bottom: -22px;
    font-size: 12px;
    transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .md-field.md-invalid .md-error {
    opacity: 1;
    transform: translateZ(0);
  }
  .md-invalid .md-error,
  .md-invalid label {
    color: #ff1744;
  }
  .field-wrapper {
    display: flex;
    max-width: 220px;
    width: 100%;
    justify-content: space-between;
  }
  .field-wrapper > .md-field:first-child {
    max-width: 65%;
  }
  .field-wrapper > .md-field:last-child {
    max-width: 25%;
  }
  .ssccToolbar {
    max-width: 150px;
    width: 150px;
    display: flex;
    align-items: baseline;
  }
  .documento > .testo{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .documento .md-field {
    margin-right: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ScaricoEdit.vue